import type { CustomAttributeData } from '@risksmart-app/domain/src/types/common.types';
import type { InsertObligationImpactMutation } from '@risksmart-app/web-graphql-client/generated/graphql';
import { InsertObligationImpactDocument } from '@risksmart-app/web-graphql-client/generated/graphql';

import { createMutationHook } from '@/utils/hook-factories';

type InsertObligationImpactInput = {
  Description: string;
  ImpactRating: number;
  ParentObligationId: string;
  CustomAttributeData?: CustomAttributeData | null;
};

export const useInsertObligationImpact = createMutationHook({
  name: 'insertObligationImpact',
  mutationOptions: (trpc, onSuccess) =>
    trpc.frontend.obligationImpact.insert.mutationOptions({ onSuccess }),
  mapInput: (input: InsertObligationImpactInput) => input,
  invalidate: (trpc) => [
    trpc.frontend.obligationImpact.getByParentId.queryKey(),
    // COI-471 parity: Apollo twin also evicts `obligation`.
    trpc.frontend.obligation.pathKey(),
  ],
  mapResponse: (result: { Id: string }): InsertObligationImpactMutation => ({
    insert_obligation_impact_one: {
      __typename: 'obligation_impact',
      Id: result.Id,
    },
  }),
  graphqlDocument: InsertObligationImpactDocument,
  graphqlVariables: (input: InsertObligationImpactInput) => ({ ...input }),
  evictFields: ['obligation_impact', 'obligation'],
});
